import { createReducer, on } from '@ngrx/store';
import { SubscriptionsActions } from './subscriptions.actions';
import {SubscriptionList} from "../../../swagger-gen/web-secured/models/subscription-list";

export const subscriptionsFeatureKey = 'Subscriptions';

export interface SubscriptionsState {
    subscriptions: SubscriptionList;
    errorMessage: string | null;
    loading: boolean;
    hasError: boolean;
}

export const initialSubscription: SubscriptionsState = {
    subscriptions: [],
    errorMessage: null,
    loading: true,
    hasError: false
};

export const subscriptionsReducer = createReducer(
    initialSubscription,
    on(
        SubscriptionsActions.fetchSuccess,
        (state, { response }): SubscriptionsState => ({
            ...state,
            subscriptions: response,
            loading: false,
            errorMessage: null,
            hasError: false
        })
    ),
    on(SubscriptionsActions.fetchFailure,
        (state, {message}) => ({
            ...state,
            errorMessage: message,
            loading: false,
            hasError: true
        })
    )
);
